module.exports = __webpack_public_path__ + "static/media/del-sol-login.7e9b7d3a.svg";